import React, { memo, useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";

import { ErrorNotification } from "../../../../components/CustomModal/ErrorNotifacation";
import { TrashIcon } from "../../../../components/icons/TrashIcon";
import type { ISimilarPrompt } from "../../../../hooks/reactQueryHooks/useCacheItems";
import { useDeleteSimilarPrompt } from "../../../../hooks/reactQueryHooks/useCacheItems";

export interface IProps {
  prompt: ISimilarPrompt;
  onDeleteSuccess: (prompt: ISimilarPrompt[]) => void;
  orgId: string;
  cacheItemId: string;
  applicationId: string;
}

const SavedSimilarPrompt: React.FC<IProps> = memo(
  ({ orgId, cacheItemId, prompt, onDeleteSuccess, applicationId }) => {
    const deleteMutation = useDeleteSimilarPrompt();
    const [error, setError] = useState<string>("");
    useEffect(() => {
      if (deleteMutation.isSuccess) {
        onDeleteSuccess(deleteMutation.data.similarPrompts);
      }
    }, [deleteMutation.isSuccess, deleteMutation.data, onDeleteSuccess]);

    useEffect(() => {
      if (deleteMutation.isError) {
        setError("Sorry, something went wrong. Please try later");
      }
    }, [deleteMutation.isError, deleteMutation.error]);

    const deletePrompt = (id: string) => {
      deleteMutation.reset();
      setError("");
      deleteMutation.mutate({
        organizationId: orgId,
        cacheItemId: cacheItemId,
        similarPromptId: id,
        applicationId,
      });
    };
    return (
      <div className="mb-5">
        <div className=" d-flex position-relative ">
          <p className="prompt-answer-similarity flex-grow-1">
            {prompt.prompt}
          </p>
          {deleteMutation.isLoading ? (
            <div className="d-flex justify-content-center align-items-center ">
              <Spinner
                className="similar-prompts__spinner"
                size="sm"
                variant="primary"
                data-testid="spinner"
              />
            </div>
          ) : (
            <Button
              variant="light"
              className="delete-button d-flex cursor-pointer justify-content-center  align-items-center ms-4"
              onClick={() => deletePrompt(prompt.id)}
            >
              <TrashIcon />
            </Button>
          )}
        </div>
        {error && <ErrorNotification message={error} />}
      </div>
    );
  },
);

export { SavedSimilarPrompt };
